module.exports = __webpack_public_path__ + "static-appopensalud/img/logo-menttum-grande-2.8b80667.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/logo-menttum-grande-2.png
// module id = 1019
// module chunks = 117